module.exports = __webpack_public_path__ + "static/media/Aalidhra6a1.05ea7972.jpg";